import { pitchCropAtom } from '@/atoms/visualisation';
import { PITCH_CROP } from '@/consts/visualisations';
import { useAtomValue } from 'jotai';

export const usePitchCrop = (isPreviewVis: boolean) => {
  const pitchCrop = useAtomValue(pitchCropAtom);
  return isPreviewVis ? PITCH_CROP[0] : pitchCrop;
};
